<div [ngClass]="{ 'full-screen-wrapper': fullScreen }">
  @if (viewConfig.loading) {
  <app-spinner-fullscreen></app-spinner-fullscreen>
  }

  <ngx-extended-pdf-viewer
    #pdfViewer
    [(page)]="page"
    [src]="src"
    [customToolbar]="additionalButtons"
    [showBorders]="fullScreen"
    [sidebarVisible]="fullScreen"
    [zoom]="zoom"
    [maxZoom]="maxZoom"
    [zoomLevels]="zoomLevels"
    [activeSidebarView]="1"
    [customSidebar]="fancySidebar"
    (pagesLoaded)="onPagesLoaded()"
    (pdfLoadingFailed)="onPagesFailed($event)"
    [showFreeFloatingBar]="fullScreen"
    [textLayer]="true"
    [ignoreKeys]="['CTRL+F', 'CMD+F']"
    [height]="'100vh'"
  >
  </ngx-extended-pdf-viewer>

  <ng-template #fancySidebar>
    <div id="sidebarContainer">
      <div id="additionalSidebarContainer">
        <div id="toolbarSidebar">
          <div id="outlineOptionsContainer" class="splitToolbarButton toggled">
            <div class="d-flex">
              <div>
                <label id="ind-pdf-select-pages-label" for="ind-pdf-page-range"
                  >Select Pages</label
                >
                <img
                  src="/icons/linear/info-circle.svg"
                  ngbTooltip="You can enter a single page or multiple pages to select for export. To enter multiple pages simply write a range of pages (ex. &quot;1-5&quot;) or you can separate pages with a comma (ex. &quot;1-5, 8-10&quot;)"
                  class="ms-1"
                  alt=""
                  placement="end"
                  container="body"
                  tooltipClass="ind-pdf-tooltip-class"
                />
              </div>
            </div>
            <div class="d-flex mt-1">
              <input
                id="ind-pdf-page-range"
                tabindex="0"
                type="text"
                (keyup)="resetPdfToOriginal($event)"
                [(ngModel)]="searchValue"
                (keyup.enter)="onSearchPages()"
                class="form-control form-control-sm"
                placeholder="eg: 1,2,3 or 1-5"
                aria-describedby="ind-pdf-page-range-hint"
              />
            </div>
            <span id="ind-pdf-page-range-hint" class="visually-hidden"
              >Enter page numbers or ranges, for example 1, 2, 3 or 1 through
              5.</span
            >
            <div class="d-flex mt-3">
              <div id="selectAllContainer" class="pe-2">
                <label for="select-all" class="d-inline-flex align-items-center gap-1 mb-0">
                  <input
                    tabindex="0"
                    id="select-all"
                    (click)="onSelectAll($event)"
                    (keydown.enter)="onSelectAll($event)"
                    (keydown.space)="onSelectAll($event)"
                    class="thumbnail-checkbox"
                    type="checkbox"
                  />
                  Select All
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pdf-sidebar-content
        [customThumbnail]="checkBoxThumbnail"
      ></pdf-sidebar-content>
      <div id="sidebarResizer" class="hidden"></div>
    </div>
  </ng-template>

  <!-- [customSidebar]="fancySidebar"  -->

  <ng-template #checkBoxThumbnail>
    <a class="pdf-viewer-template">
      <div class="thumbnail" data-page-number="PAGE_NUMBER">
        <input
          tabindex="0"
          id="PAGE_NUMBER"
          (click)="onClick($event)"
          (keydown.enter)="onClick($event)"
          (keydown.space)="onClick($event)"
          data-page-number="PAGE_NUMBER"
          class="thumbnail-checkbox"
          type="checkbox"
        />
        <div class="thumbnail-text"></div>
        <div class="image-container">
          <img [addAaTags]="'Page Number'" class="thumbnailImage" />
        </div>
        <div class="page_number">Page PAGE_NUMBER</div>
      </div>
    </a>
  </ng-template>

  <ng-template #additionalButtons>
    <div
      id="toolbarViewer"
      class="ind-pdf-viewer"
      [ngClass]="{ 'full-screen': fullScreen }"
    >
      <div id="toolbarViewerLeft">
        @if (fullScreen) {
        <pdf-toolbar class="invisible"></pdf-toolbar>
        <div class="ind-document-file-header">
          <button
            addAaTags="Close"
            tabindex="0"
            class="border border-0 bg-transparent"
            (click)="onClose()"
            (keydown.enter)="onClose()"
            (keydown.space)="onClose()"
          >
            <img
              [addAaTags]="'Close Icon'"
              src="/icons/linear/close-circle.svg"
            />
          </button>
          <div class="ind-document-label">Select Pages to Export</div>
          <!-- <div class="ind-document-pages">
            ( {{page}} / {{totalPages}} Pages )
          </div> -->
        </div>
        } @else {
          <button
            type="button"
            class="toolbarButton"
            id="viewFind"
            tabindex="0"
            aria-label="Find in document"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path fill="currentColor"
                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
              </path>
            </svg>
          </button>
        }
      </div>
      <!-- In Full Screen, middle section shows Filename -->
      @if (fullScreen) {
      <div
        class="ind-document-file-name"
        [attr.aria-label]="'Document File Name'"
      >
        <img
          [addAaTags]="'Document Icon'"
          src="icons/bold/document-text-red.svg"
        />
        <span>{{ fileName }}</span>
      </div>
      } @else {
      <div class="ind-document-pages">Page {{ page }} / {{ totalPages }}</div>
      }
      <div id="toolbarViewerRight">
        @if (fullScreen) {
        <app-button
          (click)="exportPdf()"
          (keydown.enter)="exportPdf()"
          (keydown.space)="exportPdf()"
          type="outline-dark"
          iconAlt="Export PDF Button"
          iconImg="/icons/linear/export-outline.svg"
          class="ind-button-md"
          label="Export Pages"
        ></app-button>
        <app-button
          (click)="onClose()"
          (keydown.enter)="onClose()"
          (keydown.space)="onClose()"
          type="outline-dark"
          iconAlt="Back"
          iconImg="/icons/linear/arrow-left-outline.svg"
          class="ind-button-md"
          label="Back"
        ></app-button>
        } @else {
        <pdf-zoom-dropdown class="invisible"></pdf-zoom-dropdown>
        <label for="ind-pdf-zoom-inline" class="visually-hidden"
          >Zoom Level</label
        >
        <select
          id="ind-pdf-zoom-inline"
          class="ind-document-zoom"
          [(ngModel)]="zoom"
          (keydown.capture)="onZoomSelectKeydown($event)"
        >
          <option value="auto">Auto</option>
          <option value="page-fit">Page Fit</option>
          <option value="50%">50%</option>
          <option value="75%">75%</option>
          <option value="100%">100%</option>
        </select>
        <div
          (click)="onExpandClick()"
          (keydown.enter)="onExpandClick()"
          (keydown.space)="onExpandClick()"
          tabindex="0"
          role="button"
          class="ind-document-expand"
          aria-label="Open document in full screen"
        >
          <img
            src="icons/linear/expand.svg"
            alt=""
            aria-hidden="true"
          />
        </div>
        }
      </div>
    </div>
    @if (fullScreen) {
      <div class="fixed-toolbar">
        <div id="toolbarViewer" class="ind-pdf-viewer">
          <div id="toolbarViewerLeft">
            <button
              type="button"
              class="toolbarButton full-screen"
              id="viewFind"
              tabindex="0"
              aria-label="Find in document"
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path fill="currentColor"
                  d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
                </path>
              </svg>
            </button>
          </div>
          <div class="ind-document-pages">Page {{ page }} / {{ totalPages }}</div>
          <div id="toolbarViewerRight">
            <pdf-zoom-dropdown class="invisible"></pdf-zoom-dropdown>
            <label for="ind-pdf-zoom-fullscreen" class="visually-hidden"
              >Zoom Level</label
            >
            <select
              id="ind-pdf-zoom-fullscreen"
              class="ind-document-zoom"
              [(ngModel)]="zoom"
              (keydown.capture)="onZoomSelectKeydown($event)"
            >
              <option value="auto">Auto</option>
              <option value="page-fit">Page Fit</option>
              <option value="50%">50%</option>
              <option value="75%">75%</option>
              <option value="100%">100%</option>
            </select>
          </div>
        </div>
      </div>
    }
  </ng-template>
</div>
